<template>
    <div class="h100p">
        <el-header>
            <h1><img :src="pageConfig.icon ? pageConfig.icon : require('../../assets/img/logo.png')" alt=""
                     style="width:38px;margin-top:-3px;"> {{ pageConfig.name }}</h1>
            <div class="buttonGroup">
                <span style="color:#333;font-weight:600" v-if="exam && remainingTime">{{
                    examConfig.remainingTime
                    }}&nbsp;&nbsp;{{ remainingTime }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span v-if="showTrainingBtn">
                    <span v-if="reviewMode === 'script'">
                        <span id="commit-btn" class="moving-element">请务必提交操作，避免成绩缺失<i class="el-icon-thumb" style="transform: rotate(90deg)"></i></span>
                        <el-button :disabled="loading" type="success" @click="openCommitOperation">提交操作结果</el-button>
                    </span>
                    <el-button :disabled="loading" plain type="primary" size="mini" @click="requestFullScreen">
                        {{ buttonTextConfig.fullScreen.name }}
                    </el-button>
                    <el-button :disabled="loading" plain type="primary" size="mini" @click="fileDialogVisibleOpen">
                        {{ buttonTextConfig.fileTransfer.name }}
                    </el-button>
                    <el-button :disabled="loading" plain type="primary" size="mini" @click="openTextDialog">
                        {{ buttonTextConfig.pasteText.name }}
                    </el-button>
                    <el-button disabled plain type="primary" size="mini" @click="longRange" style="display:none">
                        {{ buttonTextConfig.remote.name }}
                    </el-button>
                    <el-button :disabled="loading" plain type="primary" size="mini" @click="reset">
                        {{ buttonTextConfig.reset.name }}
                    </el-button>
                    <el-button :disabled="loading" plain type="danger" size="mini" @click="signOut">
                        {{ buttonTextConfig.exit.name }}
                    </el-button>
                </span>
            </div>
        </el-header>
        <el-container>
            <el-main v-if="loading">
                <div class="loading">
                    <h2>{{ loadingText }}</h2>
<!--                    <h2>{{ practicalTrainingTextConfig.title }}</h2>-->
                    <p v-if="!showErrorTip">{{ practicalTrainingTextConfig.tip }}</p>
                    <p v-else>{{ practicalTrainingTextConfig.tip2 }}</p>
                    <el-progress :text-inside="true" :stroke-width="20" :percentage="percentage"></el-progress>
                    <span>{{ percentage }}%</span>
                </div>
                <waves-svg v-if="examConfig.backgroundWaves"></waves-svg>
                <p class="footer" style="white-space: pre">{{ copyRightConfig }}</p>
            </el-main>

            <iframe v-show="!loading" id="oVNC" :src="src" frameborder="0" width="100%" height="100%"></iframe>
            <!-- 关闭页面 -->
            <div class="training-close" v-if="showClose">
                <div class="content">
                    <p><i class="el-icon-switch-button" style="font-size: 30px"></i></p>
                    <h2>实操环境已关闭</h2>
                    <p style="margin-top: 50px">
                        <el-button plain type="primary" size="mini" @click="start">重启环境</el-button>
                    </p>
                </div>
            </div>
        </el-container>
        <!-- 文件传输 -->
        <file-transfer ref="fileTransfer" :instancesId="instancesId"></file-transfer>
        <!-- 提交操作结果 -->
        <commit-operation-dialog  ref="commitOperation" :instancesId="instancesId" :examId="answerSheet.examId" :questionList="questionList" @postOperate="postOperationHistory"></commit-operation-dialog>
        <!-- 启动环境确认框 -->
        <start-confirm-dialog ref="startConfirmDialog" @cancel="loading=false;showClose=true" @start="stopAndRunInstance" @commitAndStart="commitAndStart"></start-confirm-dialog>
        <!-- 退出实例确认框 -->
        <logout-instance-dialog ref="logoutInstanceDialog" @cancel="loading=false;showClose=true" @signOut="onlySignOut" @commitAndSignOut="commitAndSignOut"></logout-instance-dialog>
        <!-- 粘贴文本 -->
        <el-dialog :title="pasteTextTextConfig.title" v-if="textDialogVisible" :visible.sync="textDialogVisible" width="500px"
                   @close="textClose" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-tabs v-model="textTab" type="card" @tab-click="handleClickTextDialog">
                <el-tab-pane :label="pasteTextTextConfig.form.textarea1" name="0">
                    <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 10}"
                              :placeholder="pasteTextTextConfig.form.textarea1Tip1" v-model="textarea1" clearable></el-input>
                    <p>{{ pasteTextTextConfig.form.textarea1Tip2 }}</p>
                </el-tab-pane>
                <el-tab-pane class="h100p" :label="pasteTextTextConfig.form.textarea2" name="1">
                    <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 10}"
                              :placeholder="pasteTextTextConfig.form.textarea2Tip1" v-model="textarea2" clearable></el-input>
                    <p>{{ pasteTextTextConfig.form.textarea2Tip1 }}</p>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button @click="textClose">{{ pasteTextTextConfig.cancel }}</el-button>
                <el-button type="primary" @click="pasteText()">{{ pasteTextTextConfig.ok }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import wavesSvg from '@/components/waves'
    import {getCurrentAnswer} from "@/api/exam";
    import fileTransfer from "@/views/candidate/components/fileTransfer.vue";
    import commitOperationDialog from "@/views/candidate/components/commitOperationDialog.vue";
    import startConfirmDialog from "@/views/candidate/components/startConfirmDialog.vue";
    import logoutInstanceDialog from "@/views/candidate/components/logoutInstanceDialog.vue";
    import {executeCommand, findInstancesByUser, postOperateHistory} from "@/api/training";
    import Cookies from "js-cookie";

    let errorTask = null
export default {
    name: '',
    components: {
        wavesSvg,
        fileTransfer,
        commitOperationDialog,
        startConfirmDialog,
        logoutInstanceDialog
    },
    data() {
        return {
            showTrainingBtn: true,
            pageConfig: {
                name: '',                      // 名称，原：1+X证书考试系统
                icon: '',                      // 图标（为空则按照原设计）
            },
            examConfig: {
                typeKeyword: '',                // 替换所有考试关键字，原：考试
                stuKeyword: '',                 // 替换所有考生关键字，原：考生
                backgroundImg: '',              // 考生确认页、考生等待页、实训环境加载页的背景图（为空则按照原设计）
                backgroundWaves: false,         // 考生确认页、考生等待页、实训环境加载页的背景波浪是否显示
                showInfoConfirmation: false,    // true：显示考生信息确认页；false：不显示考生信息确认页，提前登录则进入等待页面
                remainingTime: '',              // 剩余时间名称，原：考试剩余时间
                endTip: false,                  // 是否显示考试结束提示语，原：true
            },
            showErrorTip: false,
            loading: true,
            loadingText: "加载中",
            remainingTime: 0,
            remainingTimer: null,
            stop: false,
            src: '',
            http: [],
            successNum: 0,
            percentage: 0,
            filePercentage: 0,
            clickExport: false,
            textDialogVisible: false,
            textTab: 0,
            textarea1: '',
            textarea2: '',
            endTime: 0,
            instancesId: null,
            data: {},
            info: {},
            webSocket: null,
            exam: false,
            uploadUrl: null,
            uploadHeaders: '',
            showClose: false,
            trainingInfo: null,
            answerSheet: {},
            questionList: [],
            reviewMode: this.$route.query.reviewMode,
            timeDifference: 0,  // 本地时间与服务器时间差（单位毫秒）
        }
    },
    computed: {
        copyRightConfig() {
            return this.$store.state.global.textConfig.copyRight
        },
        practicalTrainingTextConfig() {
            return this.$store.state.global.textConfig.frontend.practicalTraining
        },
        buttonTextConfig() {
            return this.practicalTrainingTextConfig.button
        },
        pasteTextTextConfig() {
            return this.buttonTextConfig.pasteText
        },
        isAutoReviewQuestion() {
            let question = this.questionList.find(item => item.id == this.$route.query.examPaperQuestionId)
            if (question) {
                return question.review_mode === 'script'
            } else {
                return false
            }
        }
    },
    created() {
        errorTask = setTimeout(() => {
            this.showErrorTip = true
        }, 120000)

        let config = this.$store.state.projectConfig
        this.pageConfig = config.page
        this.examConfig = config.examModule
        this.exam = this.$route.query.exam
        let instance_name = this.exam ? 'exam_' + this.$route.query.examPaperId + '_' + this.$route.query.examPaperQuestionId : 'question_' + this.$route.query.questionId
        this.data = {training_id: this.$route.query.trainingMirror, username: this.$route.query.name, instance_name}
        if (this.exam) {
            this.$store.dispatch("getExamCurrent").then(res => {
                if (res.status == 200 && res.errorCode != 20010) {
                    this.info = res.data
                    let minute = this.getExamDurationTime(this.info.exam.examDuration, this.info.exam.examDurationUnit);
                    this.endTime = new Date(this.info.exam.startTime).getTime() + minute
                    this.timeDifference = new Date(res.data.currentTime).getTime() - new Date().getTime()
                    getCurrentAnswer().then(res => {
                        this.answerSheet = res.data
                        this.remainingTimer = setInterval(this.examCountDown, 1000)
                    })
                } else {
                    this.$message({message: this.examConfig.typeKeyword + '结束', type: 'error'});
                    this.showClose = true
                }
            })
            this.$store.dispatch("getExamPaper").then(res => {
                this.questionList = res.data.confirmed_paper.find(item => item.question_type === 'subjectivity').question_list
            })

        }

        document.addEventListener('copy', function () {
            var content = window.getSelection().toString();
            if (content.length > 0) {
                this.textarea1 = content
            }
        })
        if (this.showTrainingBtn && this.reviewMode === 'script') {
            setTimeout(() => {
                document.getElementById("commit-btn").classList.remove("moving-element")
            }, 10000)
        }
        this.openTrainingInstance()

    },
    methods: {
        start() {
            if (!this.info.exam) {
                this.showClose = true
                return false;
            } else {
                let second1 = this.getSecondByEndTime()
                let second2 = this.getSecondByDuration()
                let second = second1 < second2 ? second1 : second2

                if (second <= 0) {
                    return false;
                }
            }

            this.src = ''
            this.loading = true
            this.percentage = 0
            this.loadingText = "正在进入实训环境"
            this.showClose = false
            this.openTrainingInstance()
        },
        getUserId() {
            let token = Cookies.get('TipDM-Login-Token')
            let tokenValues = token.split('.')
            let payload = JSON.parse(atob(tokenValues[1].replace(/-/g, '+').replace(/_/g, '/'), "123"))['TipDM-Jwt-Payload']
            return JSON.parse(payload).userId
        },
        openTrainingInstance() {
            let _this = this;
            this.$store.dispatch("getTrainingInstanceSrc", _this.data.training_id).then(response => {
                _this.trainingInfo = response
                if (response.status == 200) {
                    findInstancesByUser({
                        namespaceMark: _this.$route.query.name,
                        clientMark: response.data.client_mark,
                        platformMark: response.data.platform_mark
                    }).then(userInstances => {
                        if (response.data.platform_mark === 'external_url') {
                            _this.showTrainingBtn = false
                            if (userInstances.data && userInstances.data.training_id != _this.data.training_id) {
                                this.$store.dispatch("putTrainingInstance", userInstances.data.id)
                            }
                            this.runInstances()
                        } else {
                            _this.showTrainingBtn = true;
                            // 检查是否存在已运行实例
                            if (userInstances.data && userInstances.data.training_id != this.data.training_id) {
                                this.$refs.startConfirmDialog.open(userInstances.data, this.reviewMode)
                            } else {
                                this.runInstances()
                            }

                        }

                    })

                }
            })
        },
        commitAndStart(id, questionId){
            let _this =this
            if (this.exam && questionId) {
                executeCommand(id, {
                    questionId: questionId,
                    questionCrossheadIndex: null
                }).then((res) => {
                    if (res.status == 200) {
                        _this.stopAndRunInstance(id, questionId)
                    }
                })
            }
        },
        stopAndRunInstance(id, questionId) {
            let _this =this
            _this.resetLoading("正在停止上一个实操环境")
            if (this.exam) {
                postOperateHistory({
                    "id": id,
                    "script_mark":"race",
                    "params": {"exam_id":this.answerSheet.examId, "exam_paper_id":parseInt(this.$route.query.examPaperId), "question_id":questionId, "user_id":this.getUserId(), "username":localStorage.getItem("1+XAdministration"), "question_crosshead_index":null}
                }).then(res => {
                    this.stopAndRun(id)
                })
            } else {
                this.stopAndRun(id)
            }
        },
        stopAndRun(id) {
            let _this =this
            _this.$store.dispatch("putTrainingInstance", id).then(res => {
                if (res.status == 200) {
                    var socket = new WebSocket(this.trainingInfo.data.websocket_server);
                    let hartTask = null
                    socket.onopen = function () {
                        console.log('CONNECT');
                        let message = {
                            "handler": "TrainingInstance.checkInstanceStatus",
                            "params": {
                                "id": id,
                                "status": "STOPED"
                            }
                        }
                        socket.send(JSON.stringify(message));
                        hartTask = _this.sendHart(socket)
                    };
                    socket.onclose = function () {
                        console.log('DISCONNECT');
                    };
                    socket.onmessage = function (event) {
                        console.log('MESSAGE: ' + event.data);
                        let data = JSON.parse(event.data)
                        if (data.data) {
                            if (data.data.status == 'STOPED') {
                                clearInterval(hartTask)
                                _this.runInstances()
                            }
                        }
                    };
                }
            })
        },
        runInstances() {
            let that = this
            that.webSocket = that.trainingInfo.data.websocket_server
            that.$store.dispatch("postTrainingInstance", that.data).then(r => {
                if (r.status != 200) {
                    that.stop = true
                    return
                }
                if (r.data.id) {
                    that.instancesId = r.data.id
                } else {
                    that.instancesId = r.data
                }

                let checkStatus = null
                if (r.errorCode === 20101 || r.errorCode === 20102) {
                    checkStatus = "STOPED"
                    that.resetLoading("正在停止上一个实操环境")
                } else if (r.errorCode === 20103) {
                    checkStatus = "TERMINATED"
                    that.resetLoading("正在删除上一个实操环境")
                } else {
                    checkStatus = "RUNNING"
                    that.resetLoading("正在进入实操环境")
                }

                let message = {
                    "handler": "TrainingInstance.checkInstanceStatus",
                    "params": {
                        "id": that.instancesId,
                        "status": checkStatus
                    }
                }
                let socket = new WebSocket(that.trainingInfo.data.websocket_server)
                let hartTask = null
                socket.onopen = function () {
                    socket.send(JSON.stringify(message));
                    // 发送心跳
                    hartTask = that.sendHart(socket)
                }
                socket.onmessage = function (event) {
                    let data = JSON.parse(event.data)
                    if (data.errorCode === 20106) {
                        that.showClose = true
                        clearInterval(hartTask)
                        clearTimeout(errorTask)
                    }
                    if (data.errorCode === 0 && data.data == null) {
                        if (r.data.platform_mark ==='external_url'){
                            if (r.data && r.data.training_mirror) {r
                                let url = r.data.training_mirror
                                if (url.indexOf("?") != -1) {
                                    url = url + "&modeleasySubSystemCode=race"
                                } else {
                                    url = url + "?modeleasySubSystemCode=race"
                                }
                                window.location.href = url
                            }
                        }
                    } else if (data.data) {
                        if (data.data.status == 'TERMINATED') {
                            clearInterval(hartTask)
                            that.runInstances()
                        }
                        if (data.data.status == 'STOPED') {
                            clearInterval(hartTask)
                            if (!that.exam) {
                                that.runInstances()
                            }
                            that.$store.dispatch("getExamCurrent").then(res => {
                                if (res.status == 200) {
                                    that.runInstances()
                                } else {
                                    that.showClose = true
                                }
                            })
                        }
                        if (data.data.status == 'RUNNING') {
                            clearInterval(hartTask)
                            clearTimeout(errorTask)
                            that.showVNC(that.trainingInfo.data.animation_delay_time)
                        }
                    }
                }
            })
        },
        showVNC(animation_delay_time) {
            let that = this
            that.$store.dispatch("getTrainingInstance", that.instancesId).then(res => {
                if (res.status == 200) {
                    that.src = res.data
                    that.percentage = 99
                    setTimeout(() => {
                        that.percentage = 100
                        that.loading = false
                        window.addEventListener('message', function (e) {
                            if (typeof (e.data) !== undefined) {
                                // that.textarea2 = unescape(e.data.replace(/\\/g, "%"))
                                that.textarea2 = e.data
                            }
                        }, false);
                    }, animation_delay_time * 1000);
                }
            })
        },
        examCountDown() {
            if (this.endTime) {
                let config = this.$store.state.projectConfig
                this.pageConfig = config.page
                this.examConfig = config.examModule
                this.exam = this.$route.query.exam

                let second1 = this.getSecondByEndTime()
                let second2 = this.getSecondByDuration()
                let second = second1 < second2 ? second1 : second2
                if (second == 300) {
                    this.$message({
                        type: 'Warning',
                        message: this.practicalTrainingTextConfig.autoTip.signMix(this.examConfig.typeKeyword)
                    });
                } else if (second == 10) {
                    this.$message({
                        type: 'Warning',
                        message: this.practicalTrainingTextConfig.autoTip2
                    });
                }
                this.remainingTime = this.secondFormatter(second)
                if (second <= 0) {
                    this.remainingTime = 0;
                    clearInterval(this.remainingTimer)
                    this.showClose = true
                    if (this.instancesId) {
                        if (this.exam) {
                            this.postOperationHistory(this.instancesId, parseInt(this.$route.query.examPaperQuestionId))
                        }
                        this.$store.dispatch("putTrainingInstance", this.instancesId)
                    }
                }
                if (!this.stop && this.percentage < 98) {
                    this.percentage += 2
                }
            } else {
                if (!this.stop) {
                    if (this.percentage == 97) {
                        this.percentage += 1
                    } else if (this.percentage < 98) {
                        this.percentage += 2
                    }
                    if (this.percentage == 98) {
                        this.percentage += 1
                        clearInterval(this.remainingTimer)
                    }
                }
            }
        },
        secondFormatter(second) {
            function addZero(i) {
                return i < 10 ? "0" + i : i + ""
            }
            let d = parseInt(second / (24 * 60 * 60))
            let h = parseInt(second / (60 * 60) % 24)
            let m = parseInt(second / 60 % 60)
            let s = parseInt(second % 60)
            m = addZero(m)
            s = addZero(s)
            return `${d != '0' ? d + ' 天 ' : ''}${h != '0' ? h + ' 时 ' : ''}${m != '00' ? m + ' 分 ' : ''}${s} 秒`
        },
        openCommitOperation() {
            if (this.exam) {
                if (this.info.exam.examCategory === 'normal') {
                    this.postOperationHistory(this.instancesId, parseInt(this.$route.query.examPaperQuestionId))
                    executeCommand(this.instancesId, {
                        questionId: parseInt(this.$route.query.examPaperQuestionId),
                        questionCrossheadIndex: null
                    }).then(() => {
                        this.$message.success('提交成功')
                    })
                } else {
                    this.$refs.commitOperation.open()
                }
            }
        },
        postOperationHistory(id, questionId) {
            postOperateHistory({
                "id": id,
                "script_mark":"race",
                "params": {"exam_id":this.answerSheet.examId, "exam_paper_id":parseInt(this.$route.query.examPaperId), "question_id":questionId, "user_id":this.getUserId(), "username":localStorage.getItem("1+XAdministration"), "question_crosshead_index":null}
            }).then(res => {

            })
        },
        getSecondByEndTime() {
            let nowTime = this.getNowDate().getTime()
            let endTime = new Date(this.info.exam.endTime).getTime()
            return parseInt((endTime - nowTime) / 1000)
        },
        getSecondByDuration() {
            let startTime = new Date(this.answerSheet.createdAt * 1000).getTime()
            let endTime = this.getNowDate().getTime()
            return parseInt((this.durationToSecondMill() - (endTime - startTime)) / 1000)
        },
        durationToSecondMill() {
            let secondMill = 0
            let unit = this.info.exam.examDurationUnit
            let examDuration = this.info.exam.examDuration
            if (unit === 'day') {
                secondMill = examDuration * 24 * 60 * 60000
            } else if (unit === 'hour') {
                secondMill = examDuration * 60 * 60000
            } else {
                secondMill = examDuration * 60000
            }
            return secondMill
        },
        getExamDurationTime(duration, unit) {
            let minute = 0;
            if (unit === 'day') {
                minute = duration * 24 * 60 * 60000;
            } else if (unit === 'hour') {
                minute = duration * 60 * 60000;
            } else {
                minute = duration * 60000;
            }
            return minute;
        },
        requestFullScreen() {
            let element = document.getElementById("oVNC")
            var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
            if (requestMethod) {
                requestMethod.call(element);
            }
            if (typeof window.ActiveXObject !== "undefined") {
                var wscript = new ActiveXObject("WScript.Shell");
                if (wscript !== null) {
                    wscript.SendKeys("{F11}");
                }
            }
        },
        longRange() {
            let textConfig = this.buttonTextConfig.remote
            this.$confirm(textConfig.message, textConfig.title, {
                confirmButtonText: textConfig.ok,
                cancelButtonText: textConfig.cancel,
                type: 'warning',
                dangerouslyUseHTMLString: true
            })
        },
        reset() {
            let textConfig = this.buttonTextConfig.reset
            this.$confirm(textConfig.message, textConfig.title, {
                confirmButtonText: textConfig.ok,
                cancelButtonText: textConfig.cancel,
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                this.src = ''
                this.loading = true
                this.percentage = 0
                this.loadingText = "正在重置实训环境"
                if (!this.endTime) {
                    clearInterval(this.remainingTimer)
                    this.remainingTimer = setInterval(this.examCountDown, 1000)
                }
                this.$store.dispatch("deleteTrainingInstance", this.instancesId).then(res => {
                    if (res.status == 200) {
                        setTimeout(() => {
                            this.openTrainingInstance()
                        }, 5000);
                    }
                })
            })
        },
        signOut() {
            if (this.reviewMode == "script") {
                this.$refs.logoutInstanceDialog.open(this.instancesId)
            } else {
                let textConfig = this.buttonTextConfig.exit
                this.$confirm(textConfig.message, textConfig.title, {
                    confirmButtonText: textConfig.ok,
                    cancelButtonText: textConfig.cancel,
                    type: 'warning'
                }).then(() => {
                    if (this.exam) {
                        postOperateHistory({
                            "id": this.instancesId,
                            "script_mark":"race",
                            "params": {"exam_id":this.answerSheet.examId, "exam_paper_id":parseInt(this.$route.query.examPaperId), "question_id":parseInt(this.$route.query.examPaperQuestionId), "user_id":this.getUserId(), "username":localStorage.getItem("1+XAdministration"), "question_crosshead_index":null}
                        }).then(res => {
                            this.$store.dispatch("putTrainingInstance", this.instancesId)
                        })
                    } else {
                        this.$store.dispatch("putTrainingInstance", this.instancesId)
                    }

                    this.showClose = true
                })
            }
        },
        onlySignOut() {
            if (this.instancesId) {
                if (this.exam) {
                    this.postOperationHistory(this.instancesId, parseInt(this.$route.query.examPaperQuestionId))
                }
                this.$store.dispatch("putTrainingInstance", this.instancesId)
            }
            this.showClose = true
        },
        commitAndSignOut() {
            if (this.exam) {
                executeCommand(this.instancesId, {
                    questionId: parseInt(this.$route.query.examPaperQuestionId),
                    questionCrossheadIndex: null
                }).then(() => {
                    this.onlySignOut()
                })
            } else {
                this.onlySignOut()
            }
        },
        fileDialogVisibleOpen() {
            this.$refs.fileTransfer.open()
        },
        handleClickTextDialog() {
            if (this.textTab == '1') {
                var data = {
                    function: 'getClipboard',
                    origin: '*',
                    value: '',
                };
                document.getElementById('oVNC').contentWindow.postMessage(data, '*');
            }
        },
        copy(text) {
            var textareaEl = document.createElement('textarea');
            textareaEl.setAttribute('readonly', 'readonly');
            textareaEl.value = text;
            document.body.appendChild(textareaEl);
            textareaEl.select();
            var res = document.execCommand('copy');
            document.body.removeChild(textareaEl);
            return res;
        },
        pasteText() {
            if (this.textTab == 0) {
                var data = {
                    function: 'setClipboard',
                    origin: '*',
                    value: this.textarea1,
                };
                document.getElementById('oVNC').contentWindow.postMessage(data, '*');
                this.$message({message: this.pasteTextTextConfig.success1, type: 'success'});
            } else {
                this.copy(this.textarea2)
                this.$message({message: this.pasteTextTextConfig.success2, type: 'success'});
            }
            this.textClose()
        },
        openTextDialog() {
            this.textDialogVisible = true
        },
        textClose() {
            this.textTab = '0'
            this.textarea1 = ''
            this.textarea2 = ''
            this.textDialogVisible = false
        },
        resetLoading(text) {
            if (this.percentage !== 0) {
                this.percentage = 100
            }
            setTimeout(() => {
                this.loadingText = text
                this.percentage = 0
            }, 500)
            if (!this.remainingTimer) {
                this.remainingTimer = setInterval(this.examCountDown, 1000)
            }
        },
        sendHart(ws) {
            let timeTask = setInterval(() => {
                ws.send(JSON.stringify({
                    "tip": "check hart"
                }))
            }, 10000)
            return timeTask
        },
        getNowDate() {
            return new Date(new Date().getTime() + this.timeDifference)
        }
    }
}
</script>

<style scoped>
.el-header {
    color: #0070de;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    font-size: 15px;
}

.el-header h1 {
    font-weight: 600;
    font-size: 20px;
}

.headerRight img {
    height: 40px;
    width: 40px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 12px;
}

.el-container {
    height: calc(100% - 60px);
}

.el-main {
    padding: 0;
}

.loading {
    height: calc(100% - 40px);
    text-align: center;
    width: 100%;
    background: linear-gradient(to bottom, #b2d8ff 0%, #fff 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.loading h2 {
    font-size: 22px;
    font-weight: 600;
}

.loading p {
    font-size: 14px;
    line-height: 50px;
    margin-bottom: 30px;
}

.loading span {
    font-size: 22px;
    font-weight: 600;
    display: block;
    margin-top: 20px;
    color: #0070de;
}

.loading .el-progress {
    width: 800px;
    z-index: 1;
}

.loading .el-progress >>> .el-progress-bar__outer {
    background: #fff;
    border: 3px solid #fff;
}

.loading .el-progress >>> .el-progress-bar__inner {
    background: linear-gradient(to right, #59abfb 0%, #0b78e2 100%);
}

.loading .el-progress >>> .el-progress-bar__innerText {
    display: none;
}

.buttonGroup .el-button {
    background: none;
    min-width: 70px;
    padding: 7px 10px;
    border-radius: 4px;
}

.footer {
    background: #0070de;
    color: #fff;
    line-height: 40px;
    text-align: center;
    font-size: 12px;
    width: 100%;
}

.bg2 {
    height: 336px;
    background: url("../../assets/img/bg-2.png") no-repeat;
    background-size: cover;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
}

.el-button--small.is-circle {
    padding: 4px;
    border: 0;
}

.el-button--success {
    color: #fff;
    background-color: #67c23a !important;
    border-color: #67c23a;
}

#commit-btn {
    margin-right: 5px;
}

.moving-element {
    position: relative;
    animation: move 1s linear infinite;
}

@keyframes move {
    0% { right: 0; }
    50% { right: 10px; }
    100% { right: 0; }
}

.training-close {
    width: 100%;
    height: 100%;
    background: #ffffff;
    position: absolute;
    z-index: 998;
    top: 0;
    text-align: center;
    display: grid;
    align-items: center;
    justify-content: center;
}

.training-close .content {
    width: auto;
    height: auto;
    display: inline-block;
    line-height: 40px;
}
</style>